import Order from '@/models/Order'
import BaseCollectionl from '@/models/collections/BaseCollection'

export default class OrdersList extends BaseCollectionl {
  options () {
    return {
      model: Order
    }
  }

  routes () {
    return {
      // fetch: `${APIUrl}/v1/recipes`
    }
  }
}
